if (!customElements.get("shipping-info")) {
	class ShippingInfo extends HTMLElement {
		constructor() {
			super();

			this.onButtonClick = this.onButtonClick.bind(this);
			this.onDocumentClick = this.onDocumentClick.bind(this);
			this.onKeyUp = this.onKeyUp.bind(this);
		}

		connectedCallback() {
			this.button = this.querySelector(".shipping-info__button");
			this.popoverEl = this.querySelector(".shipping-info__popover");

			if (!this.button || !this.popoverEl) return;

			this.button.addEventListener("click", this.onButtonClick);
			document.addEventListener("click", this.onDocumentClick);
			document.addEventListener("keyup", this.onKeyUp);
		}

		disconnectedCallback() {
			if (this.button) {
				this.button.removeEventListener("click", this.onButtonClick);
			}
			document.removeEventListener("click", this.onDocumentClick);
			document.removeEventListener("keyup", this.onKeyUp);
		}

		isOpen() {
			if (!this.popoverEl || typeof this.popoverEl.hasAttribute !== "function")
				return false;
			return !this.popoverEl.hasAttribute("hidden");
		}

		open() {
			if (!this.popoverEl) return;
			this.popoverEl.removeAttribute("hidden");
			if (this.button) this.button.setAttribute("aria-expanded", "true");
		}

		close() {
			if (!this.popoverEl) return;
			this.popoverEl.setAttribute("hidden", "");
			if (this.button) this.button.setAttribute("aria-expanded", "false");
		}

		toggle() {
			if (this.isOpen()) {
				this.close();
			} else {
				this.open();
			}
		}

		onButtonClick(event) {
			event.stopPropagation();
			this.toggle();
		}

		onDocumentClick(event) {
			if (!this.isOpen()) return;
			if (!this.contains(event.target)) {
				this.close();
			}
		}

		onKeyUp(event) {
			if (!this.isOpen()) return;
			if (event.code && event.code.toUpperCase() === "ESCAPE") {
				this.close();
				if (this.button) this.button.focus();
			}
		}
	}

	customElements.define("shipping-info", ShippingInfo);
}
